module.exports = __webpack_public_path__ + "img/errorNet.f5da6579.png";